export var NonCfarEnum;
(function (NonCfarEnum) {
    /**
     * Fully refundable
     */
    NonCfarEnum["AirlineRefund"] = "AirlineRefund";
    NonCfarEnum["ContactAirline"] = "ContactAirline";
    NonCfarEnum["ContactCustomerService"] = "ContactCustomerService";
    NonCfarEnum["FTC"] = "Ftc";
    NonCfarEnum["FTCWithPenalty"] = "FtcWithPenalty";
    NonCfarEnum["MultiTicket"] = "MultiTicket";
    NonCfarEnum["NonRefundable"] = "NonRefundable";
    NonCfarEnum["NonCancellable"] = "NonCancellable";
    NonCfarEnum["PartialRefund"] = "PartialRefund";
    NonCfarEnum["RefundableComplex"] = "RefundableComplex";
    NonCfarEnum["TicketedVoid"] = "TicketedVoid";
    // Rare cases where the flights service doesn't give us a void window but says it's voidable
    NonCfarEnum["TicketedVoidUnknownWindow"] = "TicketedVoidUnknownWindow";
    // Fare Optimization bookings that haven't been ticketed yet
    NonCfarEnum["DelayedTicketingCancel"] = "DelayedTicketingCancel";
    NonCfarEnum["TicketlessVoid"] = "TicketlessVoid";
    NonCfarEnum["MultiProvider"] = "MultiProvider";
    NonCfarEnum["CancellationPending"] = "CancellationPending";
})(NonCfarEnum || (NonCfarEnum = {}));
export var CancelModalFlowStepEnum;
(function (CancelModalFlowStepEnum) {
    CancelModalFlowStepEnum["loading"] = "loading";
    CancelModalFlowStepEnum["policy"] = "policy";
    CancelModalFlowStepEnum["confirm"] = "confirm";
    CancelModalFlowStepEnum["success"] = "success";
    CancelModalFlowStepEnum["nonRefundable"] = "nonrefundable";
    CancelModalFlowStepEnum["support"] = "support";
    CancelModalFlowStepEnum["pending"] = "pending";
    CancelModalFlowStepEnum["cancelled"] = "cancelled";
    CancelModalFlowStepEnum["tryAgain"] = "tryAgain";
})(CancelModalFlowStepEnum || (CancelModalFlowStepEnum = {}));
export var CancellationResponseStatus;
(function (CancellationResponseStatus) {
    CancellationResponseStatus["Success"] = "Success";
    CancellationResponseStatus["Failure"] = "Failure";
})(CancellationResponseStatus || (CancellationResponseStatus = {}));
export var CancelScenarioEnum;
(function (CancelScenarioEnum) {
    CancelScenarioEnum["PartialRefund"] = "PartialRefund";
    CancelScenarioEnum["FullyRefundableComplex"] = "FullyRefundableComplex";
    CancelScenarioEnum["NonRefundable"] = "NonRefundable";
    CancelScenarioEnum["Pending"] = "Pending";
    CancelScenarioEnum["CancellationFailure"] = "CancellationFailure";
    CancelScenarioEnum["PartiallyRefundableComplex"] = "PartiallyRefundableComplex";
    CancelScenarioEnum["FullRefund"] = "FullRefund";
    CancelScenarioEnum["ContactCustomerService"] = "ContactCustomerService";
    CancelScenarioEnum["AirlineControl"] = "AirlineControl";
    CancelScenarioEnum["BookingPending"] = "BookingPending";
    CancelScenarioEnum["CancellationPending"] = "CancellationPending";
    CancelScenarioEnum["Canceled"] = "Canceled";
    CancelScenarioEnum["Departed"] = "Departed";
    CancelScenarioEnum["NonCfar"] = "NonCfar";
    CancelScenarioEnum["TRVKOutage"] = "TRVKOutage";
})(CancelScenarioEnum || (CancelScenarioEnum = {}));
export var CarProvider;
(function (CarProvider) {
    CarProvider["avis"] = "Avis";
    CarProvider["avisRentACar"] = "Avis rent a car";
    CarProvider["avs"] = "AVS";
    CarProvider["bgt"] = "BGT";
    CarProvider["budget"] = "Budget";
    CarProvider["budgetRentACar"] = "Budget rent a car";
    CarProvider["foxRentACar"] = "Fox rent-a-car";
    CarProvider["fx"] = "FX";
    CarProvider["dollar"] = "Dollar";
    CarProvider["dollarRentACar"] = "Dollar rent a car";
    CarProvider["economyRentACar"] = "Economy rent-a-car";
    CarProvider["europcar"] = "Europcar";
    CarProvider["fox"] = "Fox";
    CarProvider["greenMotion"] = "Green motion";
    CarProvider["hertz"] = "Hertz";
    CarProvider["mexRentACar"] = "Mex rent a car";
    CarProvider["nu"] = "NU";
    CarProvider["nuCar"] = "Nu car";
    CarProvider["nuCarRentals"] = "NU car rentals";
    CarProvider["paylessCarRental"] = "Payless car rental";
    CarProvider["thrifty"] = "Thrifty";
    CarProvider["thriftyCarRental"] = "Thrifty car rental";
    CarProvider["ze"] = "ZE";
    CarProvider["zr"] = "ZR";
})(CarProvider || (CarProvider = {}));
export var FlightProvider;
(function (FlightProvider) {
    FlightProvider["sabre"] = "Sabre";
    FlightProvider["travelFusion"] = "TF";
})(FlightProvider || (FlightProvider = {}));
export var HotelProvider;
(function (HotelProvider) {
    HotelProvider["agoda"] = "Agoda";
    HotelProvider["budapest"] = "Budapest";
    HotelProvider["dhisco"] = "Dhisco";
    HotelProvider["expedia"] = "Expedia";
    HotelProvider["getARoom"] = "Getaroom";
    HotelProvider["hotelBeds"] = "Hotelbeds";
    HotelProvider["priceline"] = "Priceline";
    HotelProvider["scrape"] = "Scrape";
    HotelProvider["w2m"] = "W2m";
})(HotelProvider || (HotelProvider = {}));
//# sourceMappingURL=cancelCommon.js.map